import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid, 
  Paper,
} from "@material-ui/core";
import Appbar from "./../Appbar";
import GetProducts from "./GetProducts";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column"
  },
  main: {
    flex: 1,
    padding: theme.spacing(6, 4),
    background: '#eaeff1',
    minHeight: "100vh",
  },
  paper: {
    maxWidth: 1000,
    margin: 'auto',
    overflow: 'hidden',
    padding: theme.spacing(2)
  },
}));

const PriceChecker = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Appbar title="Products"/>
      <main className={classes.main}>
      <Grid container>
        <Grid item xs sm={2}/>
        <Grid item sm={10}>
          <Paper className={classes.paper}>
            <GetProducts />
          </Paper>
        </Grid>
      </Grid>
      </main>
    </div>
  );
};

export default PriceChecker;
